import joi from 'joi'

const schema = joi.object({
  authenticationMethodType: joi.string().required(),
  authenticationSubject: joi.string(),
  uriData: joi.object({
    uri: joi.string().required(),
    uriType: joi.string().required().valid('APP_URI', 'WEB_URI')
  }),
  authenticationCredentialReference: joi.string(),
  methodAttributes: joi
    .object({
      associatedAccountDetails: joi
        .object({
          emailAddress: joi.string().email({ tlds: false }).optional(),
          phoneNumber: joi
            .object({
              countryCode: joi
                .string()
                .regex(/^[1-9][0-9]*$/)
                .min(1)
                .max(4)
                .required(),
              phoneNumber: joi
                .string()
                .regex(/^[0-9]+$/)
                .min(4)
                .max(14)
                .required()
            })
            .optional()
        })
        .optional()
    })
    .options({ allowUnknown: true })
})

export default schema
